module.exports = {"id":"147006","name":"Diego Castro","rating":"75","photo":"./data/images/photos/2/147006.png","club":{"name":"Perth Glory","logo":"./data/images/clubs/PerthGlory.png"},"positions":["MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DiegoCastro0.json
// module id = 1073
// module chunks = 0